import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { SecurityService } from 'src/app/security/services/security.service';
import { SidebarService } from 'src/app/services';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss']
})
export class MainSidebarComponent implements OnInit {
  @Input() isCollapsed = true;
  @Output() toggle = new EventEmitter<void>();
  isAdmin = false;

  constructor(public sidebarService: SidebarService,
      private securityService: SecurityService,
      @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.securityService.isAdmin().subscribe({
        next: (isAdmin) => {
          this.isAdmin = isAdmin;
        },
        error: () => {}
      });
    }
  }

  onMouseEnter() {
    if (this.isCollapsed) {
      this.sidebarService.open();
    }
  }

  onMouseLeave() {
    this.sidebarService.close();
  }
}